import { ChangeEvent, MutableRefObject, forwardRef, useState } from 'react';

import { PaginationProps } from './Pagination.types';
import { RowPerPage } from './RowPerPage';
import { StyledPagination, StyledSpan } from './Pagination.styled';

export const Pagination = forwardRef<unknown, PaginationProps>(
  (
    { count, onChange, onRowChange, totalItem, perPageOptions, perPage = 5, ...rest }: PaginationProps,
    ref: MutableRefObject<HTMLDivElement | null>,
  ) => {
    if (perPageOptions) perPage = perPageOptions[0];

    const [rowPerPage, setRowPerPage] = useState(perPage);
    const [page, setPage] = useState(1);

    const handlePageChange = (event: ChangeEvent<unknown>, value: number) => {
      setPage(value);
      onChange?.(event, value);
    };

    const handleRowChange = (value: string) => {
      let valueAsNum = Number(value);
      onRowChange?.(valueAsNum);
      setRowPerPage(valueAsNum);
    };

    const pageCount = totalItem && rowPerPage ? Math.ceil(totalItem / rowPerPage) : count;

    return (
      <div className="nui-pagination-container" ref={ref}>
        {totalItem ? (
          <StyledSpan className="nui-total-item">
            Total {totalItem} {totalItem > 1 ? 'items' : 'item'}
          </StyledSpan>
        ) : null}
        <StyledPagination count={pageCount} onChange={handlePageChange} page={page} {...rest} />
        {rowPerPage && perPageOptions ? (
          <RowPerPage
            onRowChange={handleRowChange}
            perPageOptions={perPageOptions}
            rowPerPage={rowPerPage}
            setPage={setPage}
          />
        ) : null}
      </div>
    );
  },
);

Pagination.displayName = 'Pagination';
